<template lang="pug">
  div.record
    van-swipe(:autoplay="autoplay")
      van-swipe-item(v-for="(item, index) in images", :key="index", @click="toContentPage(item)")
        div.swiper_box
          img(:src="item.icon")
    van-row(class="record_row")
      van-col
        van-button(class="type type1", type='danger', round, v-if="activeBtn === 1") {{$t('total')}}
        van-button(class="type type1", type='danger', round, plain, v-else, @click="changeType(1)") {{$t('total')}}
      van-col
        van-button(class="type type2", type='danger', round, v-if="activeBtn === 2") {{$t('price')}}
        van-button(class="type type2", type='danger', round, plain, v-else, @click="changeType(2)") {{$t('price')}}
      van-col
        van-button(class="type type3", type='danger', round, v-if="activeBtn === 3") {{$t('sales')}}
        van-button(class="type type3", type='danger', round, plain, v-else, @click="changeType(3)") {{$t('sales')}}
      van-col
        van-button(class="type type4", type='danger', round, v-if="activeBtn === 4") {{$t('discount')}}
        van-button(class="type type4", type='danger', round, plain, v-else, @click="changeType(4)") {{$t('discount')}}
      van-col
        van-button(class="type type5", type='danger', round, v-if="activeBtn === 5") {{$t('new')}}
        van-button(class="type type5", type='danger', round, plain, v-else, @click="changeType(5)") {{$t('new')}}
    div(class="card_box")
      van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        div(class="card", v-for="item in cards", @click="toContentPage(item)")
          div.card_img
            van-tag(v-if="item.rebate > 0 && item.rebate < 10", class="card_tag", type='danger') {{item.rebate}}0% off
            div.card_img_box
              img(:src="item.icon")
          p(class="name") {{item.name}}
          p.coin
            span(v-if="item.rebate > 0 && item.rebate < 10") {{item.rebateIntegral}}{{$t('integral')}}
            span(v-if="item.rebate > 0 && item.rebate < 10", class='count_integral')  {{item.integral}}{{$t('integral')}}
            span(v-else)  {{item.integral}}{{$t('integral')}}
          p.order {{item.orderCount}}{{$t('peopleToBuy')}}
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Record',
  data(){
    return{
      listLoading: false,
      finished: false,
      loadStatus: true,
      pageNumber: 1,
      autoplay: 0,
      activeBtn: 1,
      images:[],
      cards:[]
    }
  },
  created(){
    if(this.advertiseList.advertiseList && this.advertiseList.advertiseList.length > 0){
      this.images = this.advertiseList.advertiseList
    } else {
      this.getAdvertiseList({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        type: 2
      })
    }
    // if(this.productList.list && this.productList.list.length > 0){
    //     this.cards = this.productList.list
    // } else {
      this.getProductList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          type: 0,
          language: this.lang,
          pageNumber: 1
      })
    // }
  },
  methods: {
    ...mapActions('record', ['getAdvertiseList', 'getProductList']),
    changeType(type){
      this.activeBtn = type;
      this.cards = []
      this.getProductList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          type: type - 1,
          pageNumber: 1
      })
    },
    toContentPage(item){
      // console.log(item)
      this.$router.push({
        path: '/record/content',
        query: item
      })
    },
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      this.getProductList({
          appId: this.appid,
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          type: 0,
          pageNumber: this.pageNumber
      })
    }
  },
  computed: {
    ...mapGetters(['uid', 'deviceId', 'token', 'appid', 'lang']),
    ...mapGetters('record', ['loadingAL', 'advertiseList', 'loadingPL', 'productList']),
  },
  mounted(){
    this.$watch('loadingAL', val => {
      if(val === 'loadedAL'){
        this.images = this.advertiseList.advertiseList
      }
    })
    this.$watch('loadingPL', val => {
      if(val === 'loadedPL'){
        this.productList.list.map(val => {
          this.cards.push(val)
        })
        if(this.cards.length == this.productList.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
  }
}
</script>

<style lang="scss">
.record{
  margin: 10px;
  .record_row{
    display: flex;
    overflow-x: scroll;
    &::-webkit-scrollbar{
      display: none;
    }
  }
  .type{
    margin-right: 10px;
    font-size: 12px;
    word-break: keep-all;
  }
  .van-list{
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
  }
  .van-list__finished-text{
    width: 100%;
  }
  .van-list__loading-text{
    width: 100%;
  }
  .card{
    width: 48%;
    margin-top: 10px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0px 0px 5px 2px #ebebeb;
    .card_img{
      width: 100%;
      height: 100px;
      overflow: hidden;
      position: relative;
    }
    .card_img_box{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      img{
        height: 100%;
      }
    }
    p{
      margin: 0;
    }
    .name{
      margin-top: 5px;
      font-size: 16px;
      margin-left: 5px;
      font-weight: bolder;
    }
    .coin{
      font-size: 12px;
      float: left;
      margin-left: 5px;
      margin-bottom: 5px;
      color: #e60012;
    }
    .order{
      font-size: 12px;
      float: right;
      margin-right: 5px;
      color: #d0d0d0;
    }
  }
  .card_tag{
    margin-left: 10px;
    position: absolute;
    margin-top: 5px;
    z-index: 1;
  }
  .count_integral{
    text-decoration: line-through;
    color: #d0d0d0;
  }
  .van-swipe-item{
    height: 200px;
    overflow: hidden;
    position: relative;
    background: #fff;
    .swiper_box{
      height: 100%;
      width: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      img{
        height: 100%;
      }
    }
  }
}
</style>
